module.exports = __webpack_public_path__ + "static/media/bckground1440.1f73ef63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Home/bckground1440.jpg
// module id = 1011
// module chunks = 2